import { AuthdbApi, LongpollingApi, UserApi, MovementApi, ApiClient } from '@3cad/renderfarmapi'

export const _ApiClientTest = new ApiClient();
export const rfAuthdb = new AuthdbApi(_ApiClientTest);
export const rfLongpolling = new LongpollingApi(_ApiClientTest);
export const rfUser = new UserApi(_ApiClientTest);
export const rfMovement = new MovementApi(_ApiClientTest);



// WEBPACK FOOTER //
// ./src/_eng/facades/RenderFarm.js